var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"sticky":""}},[_vm._v(" "+_vm._s(_vm.clientState)+" ")]),_c('client-form',{attrs:{"client-state":_vm.clientState,"client-prop":_vm.client}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }